import * as React from "react";

export default () => (
	<svg
		x="0"
		y="0"
		width="100%"
		height="85"
		viewBox="0 0 5.0270 5.0270"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.0000" y="0" width="0.2646" height="0.2646" />
			<rect x="0.2646" y="0" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="0" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="0" width="0.2646" height="0.2646" />
			<rect x="2.1167" y="0" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="0" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="0" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="0" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="0" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="0" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.0000" y="0.2646" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="0.2646" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="0.2646" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="0.2646" width="0.2646" height="0.2646" />
			<rect x="2.1167" y="0.2646" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="0.2646" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="0.2646" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="0.2646" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.2646" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="0.7937" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="1.5875" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="0.5292" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="0.5292" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.5292" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="0.7937" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="1.5875" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="0.7937" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="0.7937" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.2646" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="0.5292" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="1.0583" width="0.2646" height="0.2646" />
			<rect x="4.4979" y="1.0583" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.7937" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="1.5875" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="2.1167" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="1.3229" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="1.3229" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.2646" y="1.5875" width="0.2646" height="0.2646" />
			<rect x="0.5292" y="1.5875" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="1.5875" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="1.5875" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="1.5875" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="1.5875" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="1.5875" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="1.5875" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.2646" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="2.1167" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="1.8521" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="1.8521" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.2646" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="0.5292" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="0.7937" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="2.1167" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="2.1167" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.5292" y="2.3812" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="2.3812" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="2.3812" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="2.3812" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="2.3812" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="2.3812" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="2.3812" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.0000" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="0.5292" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="2.6458" width="0.2646" height="0.2646" />
			<rect x="4.4979" y="2.6458" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.0000" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="0.5292" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="2.1167" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="2.9104" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="2.9104" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.7937" y="3.1750" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="3.1750" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="3.1750" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="3.1750" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="3.1750" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="3.1750" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.0000" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="0.2646" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="1.5875" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="2.1167" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="3.4396" width="0.2646" height="0.2646" />
			<rect x="4.4979" y="3.4396" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="1.5875" y="3.7042" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="3.7042" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="3.7042" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="3.7042" width="0.2646" height="0.2646" />
			<rect x="4.4979" y="3.7042" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="3.7042" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.2646" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="0.7937" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="1.5875" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="3.9687" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="3.9687" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.2646" y="4.2333" width="0.2646" height="0.2646" />
			<rect x="1.0583" y="4.2333" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="4.2333" width="0.2646" height="0.2646" />
			<rect x="1.8521" y="4.2333" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="4.2333" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="4.2333" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="4.2333" width="0.2646" height="0.2646" />
			<rect x="4.4979" y="4.2333" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="0.0000" y="4.4979" width="0.2646" height="0.2646" />
			<rect x="0.2646" y="4.4979" width="0.2646" height="0.2646" />
			<rect x="0.5292" y="4.4979" width="0.2646" height="0.2646" />
			<rect x="1.3229" y="4.4979" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="4.4979" width="0.2646" height="0.2646" />
			<rect x="3.9687" y="4.4979" width="0.2646" height="0.2646" />
			<rect x="4.2333" y="4.4979" width="0.2646" height="0.2646" />
		</g>
		<g fill="rgb(0%,0%,0%)">
			<rect x="1.8521" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="2.1167" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="2.3812" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="2.6458" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="2.9104" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="3.1750" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="3.4396" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="3.7042" y="4.7625" width="0.2646" height="0.2646" />
			<rect x="4.7625" y="4.7625" width="0.2646" height="0.2646" />
		</g>
	</svg>
);
